import { useEffect } from 'react';
import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useSubcategories } from '../../entites/subcategories';
import { SubcategoryList } from '@ui/subcategory/subcategory-list';
import { BreadcrumbItem, Breadcrumbs } from '@heroui/react';
import { Home2 } from 'iconsax-react';
import { DesktopCategoryDashboard } from '../../entites/categories';
import { useMediaQuery } from '@uidotdev/usehooks';

export const CategoryPage = () => {
  const { categoryId } = useParams<{ categoryId: string }>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { data } = useSubcategories({
    categoryId: Number(categoryId),
    categoryTitle: searchParams.get('ct') || undefined,
  });
  const set = useNavbar();

  const isMobile = useMediaQuery('only screen and (max-width : 1023px)');

  useEffect(() => {
    set.category(searchParams.get('ct') || '');
  }, []);

  if (isMobile) {
    return <>
      <SubcategoryList items={data} />
    </>;
  }

  return (
    <div className="flex flex-col container max-w-7xl mx-auto pt-12">
      <Breadcrumbs>
        <BreadcrumbItem href="/">
          <Home2 size="24" color="#9CA5AC" />
        </BreadcrumbItem>
        <BreadcrumbItem color="primary">
          {searchParams.get('ct') || ''}
        </BreadcrumbItem>
      </Breadcrumbs>

      <div className="mt-6">
        <h1 className="text-4xl text-[#222222] font-bold">
          {searchParams.get('ct') || ''}
        </h1>
      </div>

      <DesktopCategoryDashboard
        categoryId={Number(categoryId)}
        onSelectCategory={(subcategory) => {
          const params = new URLSearchParams({
            ct: searchParams.get('ct') || '',
            st: subcategory.name || '',
          }).toString();
          navigate(
            `/category/${subcategory?.id}/${subcategory.id}?${params}`
          );
        }}
      />
    </div>
  );
};
